angular.module('jv.services')
    .service('AutomationModal', ['Reqs',
        function(Reqs) {
            let service = this;
            service.state = {
                showAutomationDetails: false,
                selectedAutomation: null,
                runAutomation: false,
                searchInput: '',
                tableLoading: true,
                page: 0,
                limit: 2,
                hasNext: true,
                hasPrev: false,
                tableData: [],
                originalTableData: [],
                displayedData: [],
                totalAffected: 0
            };

            service.callbackFunction = null;

            service.toggleModalAndDetails = function() {
                if(service.state.showAutomationDetails) {
                    service.state.showAutomationDetails = false;
                } else {
                    service.state.runAutomation = false;
                }
            };

            service.toggleDetails = function() {
                if(service.state.showAutomationDetails) {
                    service.runAutomation();
                } else {
                    service.state.showAutomationDetails = true;
                }
            };

            service.selectAutomation = function(id) {
                service.state.selectedAutomation = service.state.tableData.find(function(data) {
                    return data.id === parseInt(id);
                });

                service.conditions = service.state.selectedAutomation.condition.split(',');
                service.actions = service.state.selectedAutomation.action.split(',');
                if(service.state.selectedAutomation[0]){
                    service.secondaryActions = service.state.selectedAutomation[0].secondaryAction.split(',');
                    service.secondaryConditions = service.state.selectedAutomation[0].secondaryCondition.split(',');
                }
            };

            service.startRunAutomation = function(){
                if (service.state.tableData.length > 0 && service.state.totalAffected > 0) {
                    service.state.runAutomation = true;
                } else {
                    service.callbackFunction();
                }

            };


            service.handleSearchInputChange = function() {
                let input = service.state.searchInput;
                if (input.length > 3) {
                    const filterData = service.state.originalTableData;
                    service.state.tableData = filterData.filter(el => (el.name.toLowerCase().includes(input.toLowerCase())));
                } else {
                    service.state.tableData = service.state.originalTableData;
                }
                service.state.page = 0;
                service.updateDisplayedData();
            };

            service.runAutomation = function() {
                service.state.runAutomation = false;
                service.state.showAutomationDetails = false;
                service.callbackFunction(service.state.selectedAutomation.id);
            };

            service.getAutomationsModalData = function (referenceKey, triggerValue, type = null) {
                Reqs.getAutomations(referenceKey, triggerValue, type, function (response, status) {
                    if(status === 200){
                    const newData =  response.COMPANY_AUTOMATIONS.map((el) => {
                        const secondaryConditionsActions = el.linkedAutomations.map((linkedAutomation) => {
                            return {
                                secondaryAutomation: linkedAutomation.secondaryCompanyAutomation,
                                secondaryName: linkedAutomation.secondaryCompanyAutomation.name,
                                secondaryCondition: linkedAutomation.secondaryCompanyAutomation.displayFilters?.replace(/{([^}]*)}/g, function(_, match) {
                                    return i18n.automationEngine[match] ?? '[Translation not found]';
                                }),
                                secondaryAction: linkedAutomation.secondaryCompanyAutomation.displayActions?.replace(/{([^}]*)}/g, function(_, match) {
                                    return i18n.automationEngine[match] ?? '[Translation not found]';
                                })
                            };
                        });
                        return {
                            id: el.companyAutomationId,
                            name: el.name,
                            condition: el.displayFilters?.replace(/{([^}]*)}/g, function(_, match) {
                                return i18n.automationEngine[match] ?? '[Translation not found]';
                            }),
                            action: el.displayActions?.replace(/{([^}]*)}/g, function(_, match) {
                                return i18n.automationEngine[match] ?? '[Translation not found]';
                            }),
                            ...secondaryConditionsActions
                        };
                    });

                    service.state.tableData = newData;
                    service.state.originalTableData = newData;
                    service.state.tableLoading = false;
                    service.updateDisplayedData();
                    }
                });

                Reqs.getTotalAffected(referenceKey, triggerValue, function (response, status) {
                    if(status === 200){
                        service.state.totalAffected = response.REFERENCE_KEY_COUNT;
                    }
                });
            };

            service.updateDisplayedData = function() {
                const startIndex = service.state.page * service.state.limit;
                const endIndex = startIndex + service.state.limit;
                service.state.hasNext = (service.state.page + 1) * service.state.limit < service.state.tableData.length;
                service.state.hasPrev = service.state.page > 0;

                service.state.displayedData = service.state.tableData.slice(startIndex, endIndex);
            };

            service.nextPage = function() {
                service.state.page++;
                service.updateDisplayedData();
            };

            service.prevPage = function() {
                if (service.state.page > 0) {
                    service.state.page--;
                }
                service.updateDisplayedData();
            };

            service.updateDisplayedData();

            return service;
        }]);
